/* @flow */
import * as React from 'react';
import PropTypes from 'prop-types';

import AppboyPreaskModal from 'app/components/AppboyPreaskModal';
import BannersContainer from 'components/banners/BannersContainer';
import LimitedClassesModalContainer from 'groups/components/LimitedClassesModalContainer';
import MergeSisAccountsModals from 'organizations/components/MergeSisAccountsModals';
import ProfileCompletenessModals from 'user/components/ProfileCompletenessModals';
import QuickPromotionAppOpenedModals from 'components/QuickPromotionAppOpenedModals';
import User from 'entities/User';

import { markSeenClasses } from 'utils/accountCompletionTracker';
import { unauthorizedInterceptor } from 'lib/ResponseInterceptors';

import { registerInterceptor, unregisterInterceptor } from 'singletons/xhrInterceptors';

type Props = {
  user: ?User,
  children?: ?any,
  location: {
    query: {
      email_token?: ?string,
    },
  },
};

class AppLayout extends React.Component<Props> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  componentDidMount() {
    registerInterceptor('401-interceptor', unauthorizedInterceptor);
    const { user } = this.props;
    if (user) {
      // XXX this component isn't the /classes list
      markSeenClasses(user);
    }
  }

  componentWillUnmount() {
    unregisterInterceptor('401-interceptor');
  }

  render() {
    const { user } = this.props;
    const shouldShowBanner = user && !this.context.router.isActive('/setup');
    const emailToken = this.props.location.query.email_token;
    const hasFreeProductLimitFeature = user && user.hasFeature('free_product_limits.web.apr-19');

    return (
      <div style={{ height: '100%' }}>
        {shouldShowBanner && <BannersContainer data-test="banners-container" />}
        {this.props.children}
        {/* This component will internally only show if emailToken is defined */}
        <MergeSisAccountsModals emailToken={emailToken} />
        <QuickPromotionAppOpenedModals />
        <ProfileCompletenessModals />
        {user && <AppboyPreaskModal />}
        {hasFreeProductLimitFeature && <LimitedClassesModalContainer />}
      </div>
    );
  }
}

export default AppLayout;
